import { createStructuredSelector, createSelector } from "reselect";
import { workareaSelector } from "features/workarea/selectors";

export const isFetchingSelector = state =>
  state.ctd.getIn(["status", "isFetching"]);
// export const isFetchingModalDetailsSelector = state =>
//   state.ctd.getIn(["status", "isFetchingModalDetails"]);
export const rangeFilterSelector = state =>
  state.ctd.getIn(["status", "rangeFilter"]);
export const stageFilterSelector = state =>
  state.ctd.getIn(["status", "stageFilter"]);
export const showWirewalkerSelector = state =>
  state.ctd.getIn(["status", "showWirewalker"]);
// export const errorFilterSelector = state =>
//   state.ctd.getIn(["status", "errorFilter"]);
export const searchFilterSelector = state =>
  state.ctd.getIn(["status", "searchFilter"]);
// export const serverSearchFilterSelector = state =>
//   state.ctd.getIn(["status", "serverSearchFilter"]);
export const formDataSelector = state =>
  state.ctd.getIn(["status", "formData"]).toJS();
export const modalDataSelector = state =>
  state.ctd.getIn(["status", "modalData"]).toJS();
// export const isRecallToDeviceStatusModalOpenSelector = state =>
//   state.ctd.getIn(["status", "isRecallToDeviceStatusModalOpen"]);
// export const isRecallingToDeviceSelector = state =>
//   state.ctd.getIn(["status", "isRecallingToDevice"]);
// export const isFetchingDevicesSelector = state =>
//   state.ctd.getIn(["status", "isFetchingDevices"]);
// export const jsonModalDisplayLevelsSelector = state =>
//   state.ctd.getIn(["status", "jsonModalDisplayLevels"]);
// export const recallDeviceResponseSelector = state =>
//   state.ctd.getIn(["status", "recallDeviceResponse"]).toJS();

// export const changeOrderSubmissionIDSelector = state =>
//   state.ctd.getIn(["status", "changeOrderSubmissionID"]);

// export const processLogSelectedRowIndexSelector = state =>
//   state.ctd.getIn(["status", "processLogSelectedRowIndex"]);

// export const SubmissionErrorListSelector = state =>
//   state.ctd.getIn(["status", "submissionErrors"]).toJS();

// export const formJsonModalSearchTextSelector = state =>
//   state.ctd.getIn(["status", "formJsonModalSearchText"]);

// export const jsonFormModalOpenSelector = state =>
//   state.ctd.getIn(["status", "jsonFormModalOpen"]);

// export const recallToDeviceModalOpenSelector = state =>
//   state.ctd.getIn(["status", "recallToDeviceModalOpen"]);

// export const makeTemplateDeviceResponseSelector = state =>
//   state.ctd.getIn(["status", "makeTemplateDeviceResponse"]).toJS();
// export const makeTemplateToDeviceModalOpenSelector = state =>
//   state.ctd.getIn(["status", "makeTemplateToDeviceModalOpen"]);
// export const isSendingTemplateToDeviceSelector = state =>
//   state.ctd.getIn(["status", "isSendingTemplateToDevice"]);
// export const isMakeTemplateToDeviceStatusModalOpenSelector = state =>
//   state.ctd.getIn(["status", "isMakeTemplateToDeviceStatusModalOpen"]);

// export const formDataJSONSelector = state =>
//   state.ctd.getIn(["status", "formDataJSON"]).toJS();
// export const isFetchingFormDataJSONSelector = state =>
//   state.ctd.getIn(["status", "isFetchingFormDataJSON"]);
// export const isDeleteConfirmationOpenSelector = state =>
//   state.ctd.getIn(["status", "isDeleteConfirmationOpen"]);

// export const changeModalOpenSelector = state =>
//   state.ctd.getIn(["status", "changeModalOpen"]);

// export const jsonModalOpenSelector = state =>
//   state.ctd.getIn(["status", "jsonModalOpen"]);
// export const jsonModalDataSelector = state =>
//   state.ctd.getIn(["status", "jsonModalData"]).toJS();

// export const processLogIndexCheckedArraySelector = state =>
//   state.ctd.getIn(["status", "processLogIndexCheckedArray"]).toJS();
// export const processLogNewStatusSelector = state =>
//   state.ctd.getIn(["status", "processLogNewStatus"]);
// export const processLogToggleSelectAllSelector = state =>
//   state.ctd.getIn(["status", "processLogToggleSelectAll"]);
// export const isUpdatingProcessLogSelector = state =>
//   state.ctd.getIn(["status", "isUpdatingProcessLog"]);

export const modalDataDetailsSelector = state =>
  state.datatools.getIn(["status", "modalDataDetails"]).toJS();

export const detailsModalOpenSelector = state =>
  state.ctd.getIn(["status", "detailsModalOpen"]);

// export const deviceSelectedSelector = state =>
//   state.ctd.getIn(["status", "deviceSelected"]).toJS();

// export const devicesSelector = state =>
//   state.ctd.getIn(["status", "devices"]).toJS();

export const rowsUpdatingSelector = state =>
  state.ctd.getIn(["status", "rowsUpdating"]).toJS();

// export const tabularizedSelector = state =>
//   state.ctd.getIn(["status", "tabularized"]).toJS();

// search might be quicker if it was limited to certain fields, but they all seem important
export const formDataFilteredSelector = createSelector(
  formDataSelector,
  searchFilterSelector,
  (data, searchString) =>
    data.filter(x =>
      [
        x.hakai_id,
        x.start_dt,
        x.processing_stage,
        x.status,
        x.process_error,
        x.filename,
        x.device_sn
      ]
        .join(" ")
        .toUpperCase()
        .includes(searchString.toUpperCase())
    )
);

export default createStructuredSelector({
  searchFilter: searchFilterSelector,
  rangeFilter: rangeFilterSelector,
  stageFilter: stageFilterSelector,
  showWirewalker: showWirewalkerSelector,
  // errorFilter: errorFilterSelector,
  // isFetchingModalDetails: isFetchingModalDetailsSelector,
  isFetching: isFetchingSelector,
  formDataFiltered: formDataFilteredSelector,
  formData: formDataSelector,
  workarea: workareaSelector,
  detailsModalOpen: detailsModalOpenSelector,
  modalData: modalDataSelector,
  modalDataDetails: modalDataDetailsSelector,
  // processLogIndexCheckedArray: processLogIndexCheckedArraySelector,
  // processLogNewStatus: processLogNewStatusSelector,
  // processLogToggleSelectAll: processLogToggleSelectAllSelector,
  // jsonModalOpen: jsonModalOpenSelector,
  // jsonModalData: jsonModalDataSelector,
  // jsonFormModalOpen: jsonFormModalOpenSelector,
  // isFetchingFormDataJSON: isFetchingFormDataJSONSelector,
  // formDataJSON: formDataJSONSelector,
  // changeModalOpen: changeModalOpenSelector,
  // changeOrderSubmissionID: changeOrderSubmissionIDSelector,
  // recallToDeviceModalOpen: recallToDeviceModalOpenSelector,
  // deviceSelected: deviceSelectedSelector,
  // devices: devicesSelector,
  // isDeleteConfirmationOpen: isDeleteConfirmationOpenSelector,
  // serverSearchFilter: serverSearchFilterSelector,
  // isRecallingToDevice: isRecallingToDeviceSelector,
  // recallDeviceResponse: recallDeviceResponseSelector,
  // makeTemplateToDeviceModalOpen: makeTemplateToDeviceModalOpenSelector,
  // makeTemplateDeviceResponse: makeTemplateDeviceResponseSelector,
  // isSendingTemplateToDevice: isSendingTemplateToDeviceSelector,
  // isMakeTemplateToDeviceStatusModalOpen: isMakeTemplateToDeviceStatusModalOpenSelector,
  // isRecallToDeviceStatusModalOpen: isRecallToDeviceStatusModalOpenSelector,
  // isFetchingDevices: isFetchingDevicesSelector,
  // processLogSelectedRowIndex: processLogSelectedRowIndexSelector,
  // isUpdatingProcessLog: isUpdatingProcessLogSelector,
  // formJsonModalSearchText: formJsonModalSearchTextSelector,
  // jsonModalDisplayLevels: jsonModalDisplayLevelsSelector,
  rowsUpdating: rowsUpdatingSelector
  // tabularized: tabularizedSelector,
  // submissionErrors: SubmissionErrorListSelector
});
